exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-state[data-v-4f929cd9]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;padding:24px 16px 28px;line-height:1.5}.empty-accent[data-v-4f929cd9]{fill:#f1dfa4}.empty-illustration[data-v-4f929cd9]{display:block;width:96px;height:70px;margin-bottom:8px}.empty-title[data-v-4f929cd9]{margin:0;color:#757575;font-size:13px;font-weight:400}.empty-description[data-v-4f929cd9]{max-width:320px;margin:6px 0 0;color:#757575;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4f929cd9","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/www/newcode/platform-admin/src/style/theme.scss","/data/www/newcode/platform-admin/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/element/emptyState.vue
// module id = 855
// module chunks = 30